import { useMutation } from "@tanstack/react-query";
import { z } from "zod";
import { apiContract } from "../../lib/api";
import { useAuth } from "../../stores/auth";
import { errMessage } from "./ui";

/** Company administrators can release a report left running in another tab. */
export function CancelFinanceReport({ companyId, onCancelled }: { companyId: string | null; onCancelled: () => Promise<void> }) {
  const role = useAuth(state => state.user?.role);
  const cancel = useMutation({ mutationFn: async () => {
    const headers = companyId ? { "x-company-id": companyId } : undefined;
    const { report } = await apiContract(z.object({ report: z.object({ id: z.string().uuid() }).nullable() }),
      "/eex/recognition/finance-report/active", { headers });
    if (!report) return false;
    const result = await apiContract(z.object({ cancelled: z.boolean() }), "/eex/recognition/finance-report/cancel", {
      method: "POST", headers, body: JSON.stringify({ id: report.id }),
    });
    if (result.cancelled) await onCancelled();
    return result.cancelled;
  } });
  if (role !== "company_admin" && role !== "global_admin") return null;
  return <div className="fin-notice">
    <button type="button" className="fin-btn" disabled={cancel.isPending} onClick={() => cancel.mutate()}>
      {cancel.isPending ? "Cancelling…" : "Cancel active report"}
    </button>
    <span> Stops your company’s active report, including one running in another tab.</span>
    {cancel.isSuccess && <p role="status">{cancel.data ? "Report cancelled. Press Refresh to load a new report." : "No matching active report remains on this server. Press Refresh to retry."}</p>}
    {cancel.error && <p role="alert">Could not cancel the report: {errMessage(cancel.error)}</p>}
  </div>;
}
